import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from '@/components/ui/ScrollToTop';
import { GoogleAnalytics } from '@/components/analytics/GoogleAnalytics';
import { CookieBanner } from '@/components/analytics/CookieBanner';

interface MainLayoutProps {
  children: ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      {/* Google Analytics 4 (chargé uniquement avec consentement) */}
      <GoogleAnalytics />

      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <ScrollToTop />

      {/* Bannière de consentement cookies RGPD */}
      <CookieBanner />
    </div>
  );
}
